import React, { FC, useEffect } from 'react';
import { useAppSelector } from 'redux/store';
import { clearSentryUserContext, updateSentryUserContext } from 'helpers/sentryUserContext';
import { EUserRolesUI } from 'data/types/user.types';

type TSentryUserLayerProps = {
  children: React.ReactNode;
};

export const SentryUserLayer: FC<TSentryUserLayerProps> = ({ children }) => {
  const { users, userType, impersonateOn } = useAppSelector((state) => state.usersSlice);
  const profile = userType && userType !== EUserRolesUI.ADMIN ? users?.[userType] : null;

  useEffect(() => {
    if (profile) {
      updateSentryUserContext(profile, !!impersonateOn);
    } else {
      clearSentryUserContext();
    }
  }, [profile, impersonateOn]);

  return <>{children}</>;
};

export default SentryUserLayer;
